enum AppointmentAreaEnum {
  MEDICINE = 'medicine',
  NURSING = 'nursing',
}

export default AppointmentAreaEnum;
